import { useCallback } from "react";
import { useSelector } from "react-redux";

import { DynamicAutocompleteField } from "components/formFields/DynamicAutocompleteField";
import { LineSelectPopper } from "components/formFields/LineSelectPopper";
import {
  LineTableCell,
  LineTableHeadingCell,
} from "components/formFields/LineTableCell";

import { i18n } from "services/i18nService";
import { makeLineItemRenderInput } from "services/utility/autocomplete";
import { fetchClasses } from "services/utility/class";

export function OcostClassHeading() {
  const classEnabled = useSelector(
    (state) => state.userCompanySettings.settings.classEnabled
  );
  return (
    <>
      {classEnabled && (
        <LineTableHeadingCell>{i18n("columns.Class")}</LineTableHeadingCell>
      )}
    </>
  );
}

export function OcostClass(props) {
  const { value, classes, classesCount, onValueChange } = props;

  const classEnabled = useSelector(
    (state) => state.userCompanySettings.settings.classEnabled
  );

  const renderInput = useCallback(
    (params) => makeLineItemRenderInput(value)(params),
    [value]
  );

  return (
    <>
      {classEnabled && (
        <LineTableCell sx={{ minWidth: "13rem" }}>
          <DynamicAutocompleteField
            fullWidth
            name="class"
            options={classes}
            optionsCount={classesCount}
            fetchFn={fetchClasses}
            value={value}
            onValueChange={onValueChange}
            PopperComponent={LineSelectPopper}
            renderInput={renderInput}
          />
        </LineTableCell>
      )}
    </>
  );
}
